export default "__VITE_ASSET__CsNBUIH5__"